// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader{width:48px;height:48px;margin:220px auto auto}.loader__block{margin:auto}.loader__circle{width:100%;height:100%;border:3px solid;border-color:rgba(0,0,0,0) #d8d5dd #d8d5dd #d8d5dd;border-radius:50%;animation:spin-anim 1.5s linear infinite}@keyframes spin-anim{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}", ""]);
// Exports
module.exports = exports;
